/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { store } from "store";

import amplitude from "amplitude-js";

const UpduoAnalytics = {
  initialized: false,
};

function initialize(callback) {
  // Only perform initialization on app launches
  if (!UpduoAnalytics.initialized) {
    amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_KEY!);
    UpduoAnalytics.initialized = true;
  }
  if (callback) {
    callback();
  }
}

// Sets user ID
export function setUserId(userId) {
  // Make sure analytics is initialized before proceeding
  initialize(() => {
    amplitude.getInstance().setUserId(userId);
  });
}

// Sets user properties
export function setUserProperties(properties) {
  // Make sure analytics is initialized before proceeding
  initialize(() => {
    amplitude.getInstance().setUserProperties(properties);
  });
}

export function getTestCohort(userId: string): string {
  // Takes a string and generates some 32-bit signed integer,
  // from which we decide whether to assign to cohort A or cohort B (for A/B testing)
  let userInt = 0;
  for (let i = 0; i < userId.length; i++) {
    userInt = (userInt << 5) - userInt + userId.charCodeAt(i);
    userInt |= 0;
  }
  return userInt % 2 ? "A" : "B";
}

// Handles discrete events
export function logEvent(discreteEvent, eventPropertiesObject: {} | null = {}) {
  // Make sure analytics is initialized before proceeding
  const eventProperties = Object.assign({}, eventPropertiesObject);
  const reduxState = store.getState() as any;
  if (reduxState.selfObject.userId) {
    eventProperties["organizationId"] = reduxState.selfObject.organizationId;
    eventProperties["organizationName"] =
      reduxState.selfObject.organizationName;
    eventProperties["isStaff"] = reduxState.selfObject.isStaff;
    eventProperties["testCohort"] = getTestCohort(reduxState.selfObject.userId);
  }
  initialize(() => {
    amplitude.getInstance().logEvent(discreteEvent, eventProperties);
  });
}

export function logEventNoContext(
  discreteEvent: string,
  eventPropertiesObject: any = {}
) {
  initialize(() => {
    amplitude.getInstance().logEvent(discreteEvent, eventPropertiesObject);
  });
}
